import styles from "./CenteredSpinner.module.less";
import { Spinner } from "@digipost/dds-spinner-react";

export function CenteredSpinner() {
  return (
    <div className={styles.spinnerContainer}>
      <Spinner size={"large"} />
    </div>
  );
}
